<template>
  <div class="um-page">

    <!-- Hero -->
    <div class="um-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-account-edit-outline</v-icon>
        </v-avatar>
        <div>
          <div class="um-hero__title">Modificar Datos de Usuario</div>
          <div class="um-hero__sub" v-if="persona.pri_apellido">
            {{ persona.nombres }} {{ persona.pri_apellido }} {{ persona.seg_apellido }}
          </div>
          <div class="um-hero__sub" v-else>Edición de datos personales y configuración</div>
        </div>
      </div>
      <v-btn small dark text @click="$router.back()">
        <v-icon left small>mdi-arrow-left</v-icon> Volver
      </v-btn>
    </div>

    <form @submit.prevent="validarCampos" novalidate>
      <div class="um-body">

        <!-- Datos personales -->
        <v-card outlined class="um-section-card mb-4">
          <v-card-title class="um-section-title py-2 px-4">
            <v-icon small color="indigo darken-2" class="mr-1">mdi-account-outline</v-icon>
            Datos Personales
          </v-card-title>
          <v-card-text class="pt-4 pb-2 px-4">
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.trim="persona.num_doc"
                  label="Documento de identidad *"
                  outlined dense
                  prepend-inner-icon="mdi-card-account-details-outline"
                  :error-messages="validation.firstError('persona.num_doc')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <div class="um-field-label mb-1">Expedido (Departamento)</div>
                <Departamentos :model="persona" :default="persona.iddepartamento" />
                <div class="um-field-error" v-if="validation.firstError('persona.iddepartamento')">
                  {{ validation.firstError('persona.iddepartamento') }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model.trim="persona.sexo"
                  label="Sexo *"
                  :items="[{v:'F',t:'Mujer'},{v:'M',t:'Hombre'},{v:'O',t:'Otros'}]"
                  item-value="v" item-text="t"
                  outlined dense
                  prepend-inner-icon="mdi-gender-male-female"
                  :error-messages="validation.firstError('persona.sexo')"
                />
              </v-col>

              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.trim="persona.nombres"
                  label="Nombres *"
                  outlined dense
                  prepend-inner-icon="mdi-account-outline"
                  :error-messages="validation.firstError('persona.nombres')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.trim="persona.pri_apellido"
                  label="Apellido 1 *"
                  outlined dense
                  prepend-inner-icon="mdi-account-outline"
                  :error-messages="validation.firstError('persona.pri_apellido')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.trim="persona.seg_apellido"
                  label="Apellido 2"
                  outlined dense
                  prepend-inner-icon="mdi-account-outline"
                  :error-messages="validation.firstError('persona.seg_apellido')"
                />
              </v-col>

              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.trim="persona.email"
                  label="Correo electrónico *"
                  outlined dense
                  prepend-inner-icon="mdi-email-outline"
                  :error-messages="validation.firstError('persona.email')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model.trim="persona.diestro"
                  label="Diestro *"
                  :items="[{v:'true',t:'Sí'},{v:'false',t:'No'}]"
                  item-value="v" item-text="t"
                  outlined dense
                  prepend-inner-icon="mdi-hand-back-right-outline"
                  :error-messages="validation.firstError('persona.diestro')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <div class="um-field-label mb-1">Profesiones *</div>
                <Profesiones :model="idprofesion" v-bind:multiple="true" :default="persona.idprofesion" />
                <div class="um-field-error" v-if="validation.firstError('idprofesion.idprofesion')">
                  {{ validation.firstError('idprofesion.idprofesion') }}
                </div>
              </v-col>

              <v-col cols="12" sm="4">
                <div class="um-field-label mb-1">País</div>
                <Paises :model="persona" :default="persona.idpais" />
              </v-col>
              <v-col cols="12" sm="4">
                <div class="um-field-label mb-1">Institución de egreso</div>
                <Universidades :model="persona" :default="persona.idinstitucion" />
              </v-col>
              <v-col cols="12" sm="4">
                <div class="um-field-label mb-1">Ciudad</div>
                <Ciudades :model="persona" :default="persona.idciudad" />
              </v-col>

              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.trim="persona.telefono1"
                  label="Teléfono 1"
                  outlined dense
                  prepend-inner-icon="mdi-phone-outline"
                  :error-messages="validation.firstError('persona.telefono1')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.trim="persona.telefono2"
                  label="Teléfono 2"
                  outlined dense
                  prepend-inner-icon="mdi-phone-outline"
                  :error-messages="validation.firstError('persona.telefono2')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.trim="persona.domicilio"
                  label="Domicilio"
                  outlined dense
                  prepend-inner-icon="mdi-home-outline"
                  :error-messages="validation.firstError('persona.domicilio')"
                />
              </v-col>

              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.trim="persona.usuario_moodle"
                  label="Usuario Moodle"
                  outlined dense
                  prepend-inner-icon="mdi-school-outline"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.trim="persona.clave_moodle"
                  label="Clave Moodle"
                  outlined dense
                  prepend-inner-icon="mdi-lock-outline"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <div class="um-field-label mb-1">Fecha de nacimiento</div>
                <Fecha :model="persona" valueto="fecha_nac" :default="persona.fecha_nac" />
                <div class="um-field-error" v-if="validation.firstError('persona.fecha_nac')">
                  {{ validation.firstError('persona.fecha_nac') }}
                </div>
              </v-col>

              <v-col cols="12">
                <Menus />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Imágenes -->
        <v-row dense class="mb-4">
          <!-- Foto de perfil -->
          <v-col cols="12" sm="6">
            <v-card outlined class="um-section-card" style="height:100%;">
              <v-card-title class="um-section-title py-2 px-4">
                <v-icon small color="indigo darken-2" class="mr-1">mdi-account-circle-outline</v-icon>
                Foto de perfil
              </v-card-title>
              <v-card-text class="pt-3 px-4">
                <div class="grey--text text--darken-1 mb-3" style="font-size:0.8rem;">
                  Esta imagen se usa como foto de perfil (ranking de asesores en marketing).
                </div>
                <v-btn small depressed color="indigo lighten-5" class="indigo--text text--darken-2 mb-3"
                  @click="$refs.fotoFile.click()">
                  <v-icon left small>mdi-camera-outline</v-icon> Seleccionar imagen
                </v-btn>
                <input type="file" style="display:none;" id="fotoFile" ref="fotoFile"
                  @click="resetFotoUploader" @change="uploadFoto" accept=".jpg,.jpeg,.png" />
                <input type="hidden" v-model.trim="avatar" />
                <div class="um-field-error mb-2" v-if="validation.firstError('avatar')">
                  {{ validation.firstError('avatar') }}
                </div>
                <div class="text-center" v-if="avatar">
                  <img :src="location_user_pick + avatar" alt="avatar"
                    style="max-width:120px; max-height:120px; border-radius:8px; border:1px solid #e3e8f0;" />
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Firma -->
          <v-col cols="12" sm="6">
            <v-card outlined class="um-section-card" style="height:100%;">
              <v-card-title class="um-section-title py-2 px-4">
                <v-icon small color="indigo darken-2" class="mr-1">mdi-draw-pen</v-icon>
                Firma para recibo (Si es del area contable)
              </v-card-title>
              <v-card-text class="pt-3 px-4">
                <div class="grey--text text--darken-1 mb-3" style="font-size:0.8rem;">
                  Imagen <code>.png</code> de 250×150 px utilizada en la emisión de recibos.
                </div>
                <v-btn small depressed color="indigo lighten-5" class="indigo--text text--darken-2 mb-3"
                  @click="$refs.firmaFile.click()">
                  <v-icon left small>mdi-image-outline</v-icon> Seleccionar imagen
                </v-btn>
                <input type="file" style="display:none;" id="firmaFile" ref="firmaFile"
                  @click="resetImageUploader" @change="uploadUserFirma" accept=".jpg,.jpeg,.png" />
                <input type="hidden" v-model.trim="bg_firma" />
                <div class="um-field-error mb-2" v-if="validation.firstError('bg_firma')">
                  {{ validation.firstError('bg_firma') }}
                </div>
                <div class="text-center" v-if="bg_firma">
                  <img :src="location_user_firma + bg_firma" alt="firma"
                    style="max-width:200px; border-radius:4px; border:1px solid #e3e8f0;" />
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Cargos y sedes -->
        <v-card outlined class="um-section-card mb-4">
          <v-card-title class="um-section-title py-2 px-4">
            <v-icon small color="indigo darken-2" class="mr-1">mdi-briefcase-account-outline</v-icon>
            Cargos y Sedes
          </v-card-title>
          <v-card-text class="pt-3 pb-2 px-4">
            <div v-if="validation.firstError('cargos')" class="red--text text--darken-1 mb-2" style="font-size:0.83rem;">
              <v-icon small color="red darken-1">mdi-alert-circle-outline</v-icon>
              Indique los cargos y sedes
            </div>
            <Asignar v-show="true" :model="cargos" :default="persona.carguitos" />
          </v-card-text>
        </v-card>

        <!-- Alertas + submit -->
        <v-card outlined class="um-section-card mb-4">
          <v-card-text class="px-4 py-3">
            <Alertas ref="alertar" />
            <p v-if="msg" class="text-center mt-2 grey--text">{{ msg }}</p>
            <div class="d-flex justify-center mt-3">
              <v-btn color="indigo darken-1" dark depressed :disabled="!activo" type="submit" large>
                <v-icon left>mdi-content-save-outline</v-icon> Guardar cambios
              </v-btn>
            </div>
          </v-card-text>
        </v-card>

      </div>
    </form>

    <notifications group="auth" position="bottom right" />
    <notifications group="auth4" position="bottom right" />
  </div>
</template>

<script>
import gql from 'graphql-tag';
import Profesiones from '@/components/AProfesiones.vue';
import Departamentos from '@/components/ADepartamentos.vue';
import Paises from '@/components/APaises.vue';
import Universidades from '@/components/AUniversidades.vue';
import Ciudades from '@/components/ACiudades.vue';
import Fecha from '@/components/AFecha.vue';
import Asignar from '@/components/AAsignarCargo.vue';
import Alertas from '@/components/AAlertas.vue';
import Menus from '@/components/AMenus.vue';
import xaxios from '@/xaxios';
import { parseJsonError, error } from '@/components/Utils.js';
import { Validator } from 'simple-vue-validator';

export default {
  components: { Profesiones, Departamentos, Paises, Universidades, Ciudades, Fecha, Alertas, Menus, Asignar },
  data() {
    return {
      avatar: null,
      bg_firma: null,
      location_user_pick: process.env.VUE_APP_URL_USERPICK,
      location_user_firma: process.env.VUE_APP_URL_BG_FIRMA_USER,
      activo: true,
      msg: '',
      universidades: [],
      postgrados: [],
      sedes: [],
      gestiones: [],
      persona: {
        num_doc: null,
        nombres: null,
        pri_apellido: null,
        email: null,
        sexo: null,
        tipo: 'P',
        diestro: true,
        idprofesion: null,
        profesiones: [],
        grados: [],
        idpais: null,
        iddepartamento: null,
        idinstitucion: null,
        idciudad: null,
        contacto: null,
        datos_laborales: null,
        clave_moodle: null,
        usuario_moodle: null,
        est_civil: null,
        fecha_nac: null,
        telefono2: null,
        telefono1: null,
        domicilio: null,
        seg_apellido: null,
        carguitos: [],
      },
      idprofesion: { idprofesion: [] },
      usuario: {
        login: null,
        clave: null,
        correo_corp: null,
        observacion: null,
        foto: 'userdefault.png',
      },
      cargos: [],
    };
  },
  validators: {
    'idprofesion.idprofesion'(value) { return Validator.value(value).required(); },
    'persona.num_doc'(value) { return Validator.value(value).required().minLength(7); },
    'persona.nombres'(value) { return Validator.value(value).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$').required().minLength(2); },
    'persona.pri_apellido'(value) { return Validator.value(value).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$').required().minLength(2); },
    'persona.email'(value) {
      const v = Validator.value(value).email().required();
      const ms = Object.keys(v._messages).length;
      if (ms == 0) return Validator.value(value).regex(/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/);
      return v;
    },
    'persona.sexo'(value) { return Validator.value(value).required(); },
    'persona.tipo'(value) { return Validator.value(value).required(); },
    'persona.diestro'(value) { return Validator.value(value).required(); },
    'persona.seg_apellido'(value) { return Validator.value(value).minLength(0).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$'); },
    'persona.domicilio'(value) { return Validator.value(value).minLength(0); },
  },
  watch: {
    persona: { deep: true, handler() { window.sessionStorage.setItem('xxpersona', JSON.stringify(this.persona)); } },
    usuario: { deep: true, handler() { window.sessionStorage.setItem('xusuario', JSON.stringify(this.usuario)); } },
    'idprofesion.idprofesion': { deep: true, handler() { this.setProfesiones(); } },
  },
  methods: {
    validarCampos() {
      this.$refs.alertar.reset();
      this.parseBoolean();
      this.$validate().then((success) => {
        var obj = window.Object.assign({}, this.persona);
        var obj2 = window.Object.assign({}, this.usuario);
        delete obj.ciudad; delete obj.departamento; delete obj.pais; delete obj.usuario;
        delete obj.idprofesion; delete obj.carguitos; delete obj.__typename;
        delete obj2.__typename; delete obj2.cargos; delete obj2.datos_personales;
        delete obj2.id; delete obj2.estado; delete obj2.login; delete obj2.clave;
        if (success) {
          if (obj.iddepartamento) obj.iddepartamento = obj.iddepartamento.id;
          if (obj.idciudad) obj.idciudad = obj.idciudad.id;
          if (obj.iduniversidad) obj.idinstitucion = obj.iduniversidad.id;
          if (obj.institucion) obj.idinstitucion = obj.institucion.id;
          if (obj.idpais) obj.idpais = obj.idpais.id;
          delete obj.institucion; delete obj.iduniversidad;
          this.$store.state.obj = obj; this.$store.dispatch('quitarNulos');
          this.$store.state.obj = obj2; this.$store.dispatch('quitarNulos');
          this.activo = false;
          this.$refs.alertar.cargando();
          this.enviarDatos(obj, obj2);
        } else {
          this.$refs.alertar.invalido();
        }
      });
    },
    setProfesiones() {
      this.persona.profesiones = [];
      if (this.idprofesion.idprofesion == null) return;
      var vue = this;
      vue.idprofesion.idprofesion.forEach(function(e) { vue.persona.profesiones.push(e.id); });
    },
    parseBoolean() {
      this.persona.diestro = this.persona.diestro == 'true';
    },
    resetFotoUploader() {
      this.avatar = 'userdefault.png';
      this.$refs.fotoFile.value = '';
    },
    uploadFoto() {
      const img_cert = this.$refs.fotoFile.files[0];
      if (img_cert.size / 1000 < 1024) {
        let url = `${process.env.VUE_APP_URL_WEBDATA}fotoperfil_upload.php`;
        let formData = new FormData();
        formData.append('file', img_cert);
        xaxios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(({ data: { status, msg, newCertName } }) => {
            this.avatar = status ? newCertName : 'userdefault';
            this.$root.$notify.show(`${msg} ${newCertName}`, { color: 'success' });
            if (status) window.alert('Imagen de usuario cargada, guarde los datos para aplicar los cambios');
          })
          .catch(({ response }) => {
            this.resetFotoUploader();
            this.$root.$notify.show(`${response.data}`, { color: 'red' });
          });
      } else {
        this.resetFotoUploader();
        this.$root.$notify.show('El archivo debe ser menor a 1MB', { color: 'red' });
      }
    },
    resetImageUploader() {
      this.bg_firma = null;
      this.$refs.firmaFile.value = '';
    },
    uploadUserFirma() {
      const img_file = this.$refs.firmaFile.files[0];
      if (img_file.size / 1000 < 1024) {
        let url = `${process.env.VUE_APP_URL_WEBDATA}upload_firma_user.php`;
        let formData = new FormData();
        formData.append('file', img_file);
        xaxios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(({ data: { status, msg, fileNameFirma } }) => {
            this.bg_firma = status ? fileNameFirma : null;
            this.$root.$notify.show(`${msg} ${fileNameFirma}`, { color: 'success' });
          })
          .catch((err) => {
            this.resetImageUploader();
            this.$notify(error('Error: ' + url, err));
          });
      } else {
        this.resetImageUploader();
        this.$notify(error('Recibo', 'El archivo debe ser menor a 1MB'));
      }
    },
    getDatos() {
      this.persona.carguitos = [];
      var vue = this;
      var sql = gql`
        query{
          getPersona(id:${this.usuario.id}){
            id num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,
            email,sexo,tipo,fecha_nac,fecha_reg,diestro,usuario_moodle,ciudad{id,nombre},departamento{id,nombre,extension},
            profesiones{id,nombre},pais{id,nombre},institucion{id,nombre},usuario{firma,foto,cargos{cargo{id,nombre},sede{id,nombre},desde}}
          }
        }`;
      this.$apollo.mutate({ mutation: sql }).then((data) => {
        this.persona = data.data.getPersona;
        this.persona.iddepartamento = this.persona.departamento;
        this.persona.idciudad = this.persona.ciudad;
        this.persona.idpais = this.persona.pais;
        this.avatar = this.persona.usuario.foto;
        this.bg_firma = this.persona.usuario.firma;
        this.persona.idinstitucion = this.persona.institucion;
        if (this.persona.profesiones.length) this.persona.idprofesion = this.persona.profesiones;
        else this.persona.idprofesion = [];
        delete this.persona.profesiones;
        var cc = [];
        this.persona.usuario.cargos.forEach(function(e) {
          cc.push({ idcargo: { id: e.cargo.id, nombre: e.cargo.nombre }, idsede: { id: e.sede.id, nombre: e.sede.nombre }, desde: e.desde });
        });
        this.persona.carguitos = cc;
      }).catch((err) => {
        vue.$refs.alertar.invalido();
        this.activo = true;
        window.console.error(err);
        this.$notify(parseJsonError(err));
      });
    },
    simpleValues(obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] === null) delete obj[key];
      }
      return obj;
    },
    async enviarDatos(obj) {
      let formUser = this.simpleValues({ foto: this.avatar, firma: this.bg_firma });
      delete obj.fecha_reg;
      var vue = this;
      var sql = gql`mutation{ updateUsuarioPersona(input:{ usuario:${window.stringifyObject(formUser)},persona:${window.stringifyObject(obj)} }){ok,errors{message}} }`;
      this.$apollo.mutate({ mutation: sql }).then(({ data }) => {
        if (data.updateUsuarioPersona.ok) {
          vue.$refs.alertar.success();
          window.sessionStorage.setItem('xusuario', null);
        } else {
          var errores = JSON.parse(JSON.stringify(data.updateUsuarioPersona.errors));
          var vals = '';
          errores.forEach(function(k) { vals += Object.values(k) + '-\n\t'; });
          vue.activo = true;
          vue.$refs.alertar.invalido(vals);
        }
      }).catch((err) => {
        vue.$refs.alertar.invalido();
        this.activo = true;
        window.console.error(err);
        this.$notify(parseJsonError(err));
      });
    },
  },
  mounted() {
    var xp = sessionStorage.xxpersona;
    var xu = sessionStorage.xxusuario;
    if (xp != null) this.persona = JSON.parse(xp);
    if (xu != null) this.usuario = JSON.parse(xu);
    this.usuario.clave = '';
    this.getDatos();
  },
};
</script>

<style scoped>
.um-page { min-height: 100vh; background: #f5f7fa; }

.um-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.um-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.um-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.um-body { padding: 20px 24px; }

.um-section-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.um-section-title {
  font-size: 0.82rem !important;
  font-weight: 700 !important;
  color: #283593;
  letter-spacing: 0.02em;
  border-bottom: 1px solid #e8edf7;
}

.um-field-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #7986cb;
}

.um-field-error {
  font-size: 0.75rem;
  color: #c62828;
  margin-top: 2px;
}
</style>
